import { WUJI_DEPS_KEY } from '../consts';
import { pick } from 'lodash';
/**
 * 使用cdn加载依赖
 *
 * 保留这个不仅仅是为了兼容旧的加载逻辑，还因为像是echarts这种依赖通过它加载的速度比npm下载的速度快很多
 */
class CdnLoader {
    modules = new Map();
    constructor() {
        this.modules = new Map();
    }
    register(module) {
        if (this.modules.has(module)) {
            return;
        }
        window.require.config({
            paths: {
                [module]: `https://cdn.jsdelivr.net/npm/${module}?noext`,
            },
        });
        this.modules.set(module, true);
    }
    async load(dependencies) {
        dependencies.forEach(this.register.bind(this));
        const modules = await new Promise((resolve, reject) => {
            window.require(dependencies, (...modules) => {
                resolve(modules);
            }, (error) => {
                reject(error);
            });
        });
        dependencies.forEach((dep, index) => {
            this.modules.set(dep, modules[index]);
            window[WUJI_DEPS_KEY][dep] = modules[index];
        });
        return pick(this.modules, dependencies);
    }
}
export default CdnLoader;
